<ng-container *ngIf="spin">
  <ion-thumbnail (click)="_onClick()">
    <div class="border d-flex justify-content-center align-items-center text-break text-center" style="width: 80px;height: 80px;">
      <ion-spinner name="circular" color="medium"></ion-spinner>
    </div>
  </ion-thumbnail>
</ng-container>
<ng-container *ngIf="!spin">
  <ion-thumbnail (click)="_onClick()" *ngIf="isNotReady()">
    <div class="border d-flex justify-content-center align-items-center text-break text-center" style="width: var(--size-width, 80px);height: var(--size-height , 80px);">
      <ion-icon [color]="getPhotoColor(photo)" slot="start" name="camera-outline" size="large"></ion-icon>
    </div>
  </ion-thumbnail>
  <!-- <ion-thumbnail (click)="_onClick()" *ngIf="!isNotReady()">
    <img class="border" [src]="imageUrl" alt="">
  </ion-thumbnail> -->
  <div class="photo-thumbnail" (click)="_onClick()" *ngIf="!isNotReady()" [style.background-image]="imageUrlBackground">
    <!-- cover -->
  </div>
</ng-container>
